import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface Props {
    portSide: 'in' | 'out' | 'special';
    portColor?: string;
    children: ReactNode;
}

export const PortOverlayContainer: React.FC<Props> = ({ portSide, portColor, children }) => {
    const isLeft = portSide === 'in' || portSide === 'special';
    const isOut = portSide === 'out';
    const blobOrigin = isLeft ? 'right' : 'left';

    return (
        <div
            style={{
                minWidth: isOut ? 200 : 280,
                maxWidth: 450,
                maxHeight: 750,
                overflowY: 'auto',
                position: 'relative',
            }}
            className={cn(
                'animate-in fade-in duration-150 rounded-xl shadow-xl px-3 pb-3 pt-2',
                isLeft ? 'slide-in-from-left-2' : 'slide-in-from-right-2',
                isOut
                    ? 'bg-white/90 dark:bg-neutral-900/90 backdrop-blur-xl border border-neutral-200/60 dark:border-neutral-700/60 shadow-lg'
                    : 'bg-white/60 dark:bg-neutral-900/60 backdrop-blur-xl border border-white/30 dark:border-neutral-700/50',
            )}
        >
            {portColor && (
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        borderRadius: 'inherit',
                        background: `radial-gradient(circle at ${isLeft ? '120% -20%' : '-20% -20%'}, ${portColor}18 0%, ${portColor}08 40%, transparent 80%)`,
                        transformOrigin: `${blobOrigin} top`,
                        animation: 'port-overlay-blob 150ms ease-out forwards',
                        pointerEvents: 'none',
                    }}
                />
            )}
            <style>{`
                @keyframes port-overlay-blob {
                    from { transform: scale(0); }
                    to { transform: scale(1); }
                }
            `}</style>
            <div style={{ position: 'relative' }}>{children}</div>
        </div>
    );
};
